<div
  class="device-container"
  style="margin: 10px; display: flex; justify-content: flex-end"
>
  <app-safe-select
    style="width: 300px"
    [options]="deviceOptions"
    [(value)]="selectedValue"
    [placeholder]="'Select Camera'"
    [allowClear]="true"
  ></app-safe-select>
</div>

<div class="scanner-shell" style="margin-bottom: 100px">
  <div class="scanner-viewport">
    <!-- 1. Start Button (Crucial for permissions) -->
    <!-- We hide this ONLY when camera is active -->
    @if (!isCameraActive() && libraryLoaded()) {
      <div class="placeholder">
        <div class="icon-camera">📷</div>
        <p>Ready to Scan</p>
        <button class="btn-primary" (click)="startScanner()">
          Start Camera
        </button>
        @if (permissionError()) {
          <p class="error-text">{{ permissionError() }}</p>
        }
      </div>
    } @else if (!libraryLoaded()) {
      <div class="placeholder">
        <p>Loading Scanner Library...</p>
      </div>
    }

    <!-- 2. The Scanner Container -->
    <!-- The library needs a visible container to calculate video dimensions -->
    <div id="reader"></div>
    @if (isCameraActive()) {
      <button class="btn-secondary" (click)="stopScanner()">Stop Camera</button>
    }
  </div>

  <!-- 3. Camera Selection -->
  @if (cameras().length > 1 && isCameraActive()) {
    <div class="controls">
      <label>Switch Camera:</label>
      <select (change)="onCameraChange($event)">
        @for (cam of cameras(); track cam.id) {
          <option [value]="cam.id" [selected]="cam.id === currentCameraId">
            {{ cam.label }}
          </option>
        }
      </select>
    </div>
  }

  <!-- 4. Result Display -->
  @if (scanResult()) {
    <div class="result-card">
      <h3>✅ Scan Successful</h3>
      <p class="code-content">{{ scanResult() }}</p>
      <button (click)="scanResult.set('')">Scan Another</button>
    </div>
  }
</div>
